













import { computed, defineComponent } from '@vue/composition-api';
import { Icon } from '@iconify/vue2';

export default defineComponent({
    name: 'NotificationSuggestionIcon',
    components: {
        Icon,
    },
    props: {
        eventType: {
            type: String,
            required: true,
        },
        dropdown: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const iconType = computed(() => {
            switch (props.eventType) {
                case 'concept.created':
                    return 'neutral';
                case 'concept.approved':
                    return 'success';
                case 'concept.rejected':
                case 'concept.deleted':
                    return 'fail';
                default:
                    return 'neutral';
            }
        });

        return {
            iconType,
        };
    },
});
